// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GNoO","tab":"styles_tab__1xXWz","selectedTab":"styles_selectedTab__2Mekr","indicator":"styles_indicator__Rx4hI"};